export const REFERRER_KEY = 'referrer';
export const ADVANCED_API_REFERRER = 'advanced_trade';
